<template>
  <div class="container-fluid py-4">
    <!-- Header assurances -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique flex-wrap">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-shield-check fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Assurances</h2>
      </div>
      <button class="btn btn-primary btn-lg shadow-sm btn-clinique mt-2 mt-md-0" @click="creation">
        <i class="bi bi-plus-circle me-2"></i> Création
      </button>
    </div>

    <!-- Card filtrage et tableau -->
    <div class="card p-3 p-md-4 shadow-sm rounded card-clinique">
      <!-- Filtres -->
      <div class="row mb-3 g-3 justify-content-end">
        <div class="col-12 col-md-3">
          <input v-model="searchQuery" class="form-control form-control-clinique" placeholder="Rechercher..." />
        </div>
        <div class="col-6 col-md-2">
          <select v-model="itemsperpage" class="form-select form-select-clinique">
            <option v-for="item in itemsPerPageT" :key="item" :value="item">{{ item }}</option>
          </select>
        </div>
        <div class="col-6 col-md-3">
          <select v-model="orderBy" class="form-select form-select-clinique">
            <option v-for="(value, key) in orderByTabs" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
        <div class="col-6 col-md-2">
          <select v-model="sortOrder" class="form-select form-select-clinique">
            <option v-for="(value, key) in sortOrders" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
      </div>

      <!-- Tableau -->
      <div class="table-responsive overflow-auto">
        <table class="table table-hover table-bordered align-middle text-center w-100">
          <thead class="table-primary">
            <tr>
              <th>#</th>
              <th>Nom</th>
              <th class="d-none d-sm-table-cell">Taux de couverture (%)</th>
              <th class="d-none d-sm-table-cell">Contact</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(assurance, index) in filteredAssurances" :key="assurance.id">
              <td>{{ index + 1 + (currentPage - 1) * itemsperpage }}</td>
              <td>{{ assurance.nom }}</td>
              <td class="d-none d-sm-table-cell">{{ assurance.tauxCouverture }}%</td>
              <td class="d-none d-sm-table-cell">{{ assurance.contact || '—' }}</td>
              <td>
                <span :class="assurance.isEnabled ? 'text-success' : 'text-danger'">
                  {{ assurance.isEnabled ? 'Activée' : 'Désactivée' }}
                </span>
              </td>
              <td>
                <div class="dropdown text-center">
                  <button
                    class="btn btn-sm btn-outline-primary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    ⋮
                  </button>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item" @click="modifier(assurance.id)">Modifier</a></li>
                    <!--<li>
                      <a class="dropdown-item" @click="changerStatus(assurance)">
                        {{ assurance.isEnabled ? 'Désactiver' : 'Activer' }}
                      </a>
                    </li>-->
                    <li><a class="dropdown-item text-danger" @click="supprimer(assurance.id)">Supprimer</a></li>
                  </ul>
                </div>
              </td>
            </tr>
            <tr v-if="assurances.length === 0">
              <td colspan="6" class="text-center">Aucune donnée disponible</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <nav>
        <ul class="pagination justify-content-end flex-wrap">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)">Précédent</button>
          </li>
          <li
            v-for="page in totalPages"
            :key="page"
            class="page-item"
            :class="{ active: page === currentPage }"
          >
            <button class="page-link" @click="changePage(page)">{{ page }}</button>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)">Suivant</button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      searchQuery: '',
      itemsperpage: 10,
      orderBy: 'ass.nom',
      sortOrder: 'asc',
      assurances: [],
      totalItems: 0,
      currentPage: 1,
      itemsPerPageT: [5, 10, 20],
      orderByTabs: {
        Nom: 'ass.nom',
        Couverture: 'ass.tauxCouverture',
        Statut: 'ass.isEnabled',
      },
      sortOrders: {
        Croissant: 'asc',
        Décroissant: 'desc',
      }
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsperpage);
    },
    filteredAssurances() {
      if (!this.searchQuery) return this.assurances;
      return this.assurances.filter(ass =>
        ass.nom.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    }
  },
  methods: {
    async getAssurances() {
      try {
        const res = await api.getItems('assurances', {
          page: this.currentPage,
          itemsperpage: this.itemsperpage,
          orderBy: this.orderBy,
          sortOrder: this.sortOrder,
          search: this.searchQuery
        });
        this.assurances = res.data.data;
        this.totalItems = res.data.meta?.total_records || 0;
      } catch (err) {
        console.error('Erreur de chargement des assurances :', err);
      }
    },
    changePage(page) {
      this.currentPage = page;
      this.getAssurances();
    },
    creation() {
      this.$router.push({ name: 'create_assurance' });
    },
    modifier(id) {
      this.$router.push({ name: 'edit_assurance', params: { id } });
    },
    async changerStatus(assurance) {
      try {
        await api.patchItem('assurances', assurance.id, { isEnabled: !assurance.isEnabled });
        this.getAssurances();
      } catch (err) {
        alert('Erreur lors du changement de statut');
      }
    },
    async supprimer(id) {
      if (confirm('Voulez-vous supprimer cette assurance ?')) {
        await api.deleteItem('assurances', id);
        this.getAssurances();
      }
    }
  },
  watch: {
    searchQuery() {
      this.currentPage = 1;
      this.getAssurances();
    },
    itemsperpage() {
      this.currentPage = 1;
      this.getAssurances();
    },
    orderBy() {
      this.getAssurances();
    },
    sortOrder() {
      this.getAssurances();
    }
  },
  created() {
    this.getAssurances();
  }
};
</script>

<style scoped>
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}

.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}

.form-control-clinique,
.form-select-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 10px 14px;
  transition: all 0.3s ease;
}
.form-control-clinique:focus,
.form-select-clinique:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}

.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.btn-clinique:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  transform: translateY(-2px);
}

.table th,
.table td {
  vertical-align: middle;
}

.pagination .page-item .page-link {
  color: #007bff;
}
.pagination .page-item.active .page-link {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}

/* Responsive adjustments */
@media (max-width: 767px) {
  .table td,
  .table th {
    padding: 0.4rem 0.5rem;
    font-size: 0.85rem;
  }

  .btn-clinique {
    width: 100%;
  }

  .header-clinique {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}
</style>
